import React from 'react'
import './services.css'
import {AiOutlineCheck} from 'react-icons/ai'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className='container services__container'>
        <article className='services__content'>
          <div className='content__head'>
            <h3>UX/UI Design</h3>
          </div>
          <ul className='services__list'>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Coming Soon...</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>LOADING...</p>
            </li>
            {/* <li>
              <AiOutlineCheck className='services__icon' />
              <p>Lorem ipsum dolor sit amet adipisicing elit.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Lorem ipsum dolor sit amet adipisicing elit.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Lorem ipsum dolor sit amet adipisicing elit.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Lorem ipsum dolor sit amet adipisicing elit.</p>
            </li> */}
          </ul>
        </article>
        {/* UX/UI END */}

        <article className='services__content'>
          <div className='content__head'>
            <h3>Web Developement</h3>
          </div>
          <ul className='services__list'>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Custom website.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert figma to react.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert psd to react.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert sketch to react.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert xd to react.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Pixel Perfect Design.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>100% Mobile Responsive design.</p>
            </li>
          </ul>
        </article>
        {/* WEB DEVELOPEMENT END */}

        <article className='services__content'>
          <div className='content__head'>
            <h3>Mobile Developement</h3>
          </div>
          <ul className='services__list'>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Custom React Native App.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert figma to react native.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert psd to react native.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert sketch to react native.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>Convert xd to react native.</p>
            </li>
            <li>
              <AiOutlineCheck className='services__icon' />
              <p>100% Responsive design.</p>
            </li>
          </ul>
        </article>


      </div>
    </section>
  )
}

export default Services